import React, { useState } from "react";
import {
  Box,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SIDEBAR_DATA } from "./SidebarMenuItem";

// Container styling for the sidebar
const Container = styled(Box)({
  padding: 8,
  "& > ul": {
    padding: "10px 0 0 5px",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  "& > ul > li> svg": {
    marginRight: 10,
  },
});

// Custom styling for the ListItemButton with hover and active states
const CustomListItemButton = styled(ListItemButton)(({ isActive }) => ({
  "&:hover": {
    background:
      "transparent linear-gradient(90deg, #47d7ac 0%, #4a90e200 100%) 0% 0% no-repeat padding-box",
    cursor: "pointer",
    color: "#fff !important",
    opacity: "1 !important",
  },
  ...(isActive && {
    background:
      "transparent linear-gradient(90deg, #47d7ac 0%, #4a90e2 100%) 0% 0% no-repeat padding-box",
    color: "#fff !important",
    opacity: "1 !important",
  }),
}));

// Custom styling for the ListItemIcon
const CustomListItemIcon = styled(ListItemIcon)({
  minWidth: 20,
});
const SideBarContent = ({ userData, openDrawer, active }) => {
  const isAdmin = userData.isAdmin;
  const navigate = useNavigate();
  const [hideSideBar, setHideSideBar] = useState(false);

  // Function to handle navigation
  const changeNavigation = (path) => {
    navigate(`${path}`, {
      state: {
        ...userData,
      },
    });
  };
  return (
    <Container openDrawer={openDrawer}>
      <List>
        {SIDEBAR_DATA.map((data) => {
          if (data.level === 0 && (isAdmin ? true : !data.admin)) {
            return (
              <>
                <ListItem key={data.name} disablePadding>
                  <CustomListItemButton
                    isActive={active === data.index}
                    onClick={() => changeNavigation(data.name)}
                  >
                    {openDrawer && (
                      <>
                        <ListItemIcon style={{ color: "var(--white-color)" }}>
                          {data.icon}
                        </ListItemIcon>
                        <ListItemText
                          style={{ justifyContent: "initial" }}
                          primary={data.title}
                        />
                      </>
                    )}
                    {!openDrawer && (
                      <CustomListItemIcon
                        style={{ color: "var(--white-color)", paddingTop: 10 }}
                      >
                        {data.icon}
                      </CustomListItemIcon>
                    )}
                  </CustomListItemButton>
                </ListItem>
                <Divider style={{ backgroundColor: "var(--white-color)" }} />
              </>
            );
          }
          // Render nested sidebar items
          else if (data.level === 1 && (isAdmin ? true : !data.admin)) {
            return (
              <>
                <List>
                  <ListItem key={data.name} disablePadding>
                    <CustomListItemButton
                      onClick={() => setHideSideBar(!hideSideBar)}
                    >
                      {openDrawer && (
                        <>
                          <ListItemIcon
                            openDrawer={openDrawer}
                            style={{ color: "var(--white-color)" }}
                          >
                            {data.icon}
                          </ListItemIcon>
                          <ListItemText
                            style={{ justifyContent: "initial" }}
                            primary={data.title}
                          />
                          {hideSideBar ? <ExpandLess /> : <ExpandMore />}
                        </>
                      )}
                      {!openDrawer && (
                        <>
                          <CustomListItemIcon
                            style={{
                              color: "var(--white-color)",
                              paddingTop: 10,
                            }}
                          >
                            {data.icon}
                          </CustomListItemIcon>
                          {hideSideBar ? <ExpandLess /> : <ExpandMore />}
                        </>
                      )}
                    </CustomListItemButton>
                  </ListItem>
                  <Collapse in={hideSideBar} timeout="auto" unmountOnExit>
                    {data.innerSidebars.map((innerData) => {
                      return (
                        <>
                          <List
                            component="div"
                            disablePadding
                            style={{ paddingLeft: 15 }}
                          >
                            <CustomListItemButton
                              sx={{}}
                              isActive={active === innerData.innerIndex}
                              onClick={() =>
                                changeNavigation(
                                  `${data.name}${innerData.name}`
                                )
                              }
                            >
                              {openDrawer && (
                                <>
                                  <ListItemIcon
                                    openDrawer={openDrawer}
                                    style={{ color: "var(--white-color)" }}
                                  >
                                    {innerData.icon}
                                  </ListItemIcon>
                                  <ListItemText
                                    style={{ justifyContent: "initial" }}
                                    primary={innerData.title}
                                  />
                                </>
                              )}
                              {!openDrawer && (
                                <>
                                  <CustomListItemIcon
                                    style={{
                                      color: "var(--white-color)",
                                      paddingTop: 10,
                                    }}
                                  >
                                    {innerData.icon}
                                  </CustomListItemIcon>
                                </>
                              )}
                            </CustomListItemButton>
                          </List>
                        </>
                      );
                    })}
                  </Collapse>
                  <Divider style={{ backgroundColor: "var(--white-color)" }} />
                </List>
              </>
            );
          }
        })}
      </List>
    </Container>
  );
};

export default SideBarContent;
